<div class="blood-report-history-container">

  <ng-container *ngIf="!isLoading">
    <div *ngIf="bloodReportSummaries?.length; else noBloodReports" class="blood-report-cards-list">

      <div
        class="blood-report-card"
        *ngFor="let report of bloodReportSummaries; let i = index"
        [class.expanded]="isReportExpanded(i)">

        <!-- Card Header (always visible) -->
        <div class="blood-report-card-header">
          <div class="blood-report-header-left">
            <span class="blood-report-uploaded-at">
              Uploaded At : {{ formatUploadedAt(report.reportCreated) }}
            </span>
          </div>
          <div class="blood-report-header-right">
            <button
              *ngIf="report.bloodReportAnalysisUrl"
              type="button"
              class="blood-report-view-button"
              (click)="onBloodReportViewReport(report)">
              View Report
            </button>
            <mat-icon class="expand-icon" (click)="toggleReportExpansion(i, report)">
              {{ isReportExpanded(i) ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}
            </mat-icon>
          </div>
        </div>

        <!-- Expandable Body -->
        <div class="blood-report-card-body" *ngIf="isReportExpanded(i)">

          <!-- Per-card loading spinner -->
          <div *ngIf="isLoadingSmartSections(report.reportId)" class="smart-sections-loading">
            <div class="css-spinner"></div>
          </div>

          <ng-container *ngIf="!isLoadingSmartSections(report.reportId)">
            <div *ngIf="getSmartSections(report.reportId).length; else noSections">
              <div *ngFor="let section of getSmartSections(report.reportId)" class="smart-section">
                <h3 class="section-title">{{ section.section_name }}</h3>

                <!-- ABNORMAL table -->
                <div *ngIf="section.abnormal && section.abnormal.length" class="severity-block">
                  <h4 class="severity-title abnormal-title">ABNORMAL (Needs attention)</h4>
                  <table class="results-table">
                    <thead>
                      <tr>
                        <th>Test Name</th>
                        <th>Result</th>
                        <th>Reference Range</th>
                        <th>Status</th>
                        <th>Range Type</th>
                        <th>Severity</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let item of section.abnormal">
                        <td>{{ item['Test Name'] }}</td>
                        <td>{{ item.Value }} {{ item.Units }}</td>
                        <td>
                          <ng-container *ngIf="item.Low || item.High; else noRangeAbnormal">
                            <span *ngIf="item.Low">{{ item.Low }}</span>
                            <span *ngIf="item.Low && item.High">–</span>
                            <span *ngIf="item.High">{{ item.High }}</span>
                            <span *ngIf="item.Units">&nbsp;{{ item.Units }}</span>
                          </ng-container>
                          <ng-template #noRangeAbnormal>–</ng-template>
                        </td>
                        <td>{{ item.Status }}</td>
                        <td>{{ item.RangeType }}</td>
                        <td>{{ item.Severity }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <!-- BORDERLINE table -->
                <div *ngIf="section.borderline && section.borderline.length" class="severity-block">
                  <h4 class="severity-title borderline-title">BORDERLINE (At-risk)</h4>
                  <table class="results-table">
                    <thead>
                      <tr>
                        <th>Test Name</th>
                        <th>Result</th>
                        <th>Reference Range</th>
                        <th>Status</th>
                        <th>Range Type</th>
                        <th>Severity</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let item of section.borderline">
                        <td>{{ item['Test Name'] }}</td>
                        <td>{{ item.Value }} {{ item.Units }}</td>
                        <td>
                          <ng-container *ngIf="item.Low || item.High; else noRangeBorderline">
                            <span *ngIf="item.Low">{{ item.Low }}</span>
                            <span *ngIf="item.Low && item.High">–</span>
                            <span *ngIf="item.High">{{ item.High }}</span>
                            <span *ngIf="item.Units">&nbsp;{{ item.Units }}</span>
                          </ng-container>
                          <ng-template #noRangeBorderline>–</ng-template>
                        </td>
                        <td>{{ item.Status }}</td>
                        <td>{{ item.RangeType }}</td>
                        <td>{{ item.Severity }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <!-- GOOD table -->
                <div *ngIf="section.good && section.good.length" class="severity-block">
                  <h4 class="severity-title good-title">GOOD (Normal)</h4>
                  <table class="results-table">
                    <thead>
                      <tr>
                        <th>Test Name</th>
                        <th>Result</th>
                        <th>Reference Range</th>
                        <th>Status</th>
                        <th>Range Type</th>
                        <th>Severity</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let item of section.good">
                        <td>{{ item['Test Name'] }}</td>
                        <td>{{ item.Value }} {{ item.Units }}</td>
                        <td>
                          <ng-container *ngIf="item.Low || item.High; else noRangeGood">
                            <span *ngIf="item.Low">{{ item.Low }}</span>
                            <span *ngIf="item.Low && item.High">–</span>
                            <span *ngIf="item.High">{{ item.High }}</span>
                            <span *ngIf="item.Units">&nbsp;{{ item.Units }}</span>
                          </ng-container>
                          <ng-template #noRangeGood>–</ng-template>
                        </td>
                        <td>{{ item.Status }}</td>
                        <td>{{ item.RangeType }}</td>
                        <td>{{ item.Severity }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

              </div>
            </div>

            <ng-template #noSections>
              <div class="no-smart-sections">No summary data available for this report.</div>
            </ng-template>
          </ng-container>

        </div>
      </div>
    </div>

    <ng-template #noBloodReports>
      <div class="no-blood-reports-text">
        No blood report history available.
      </div>
    </ng-template>
  </ng-container>

  <div class="blood-report-paginator" *ngIf="bloodReportTotalCount > bloodReportPageSize">
    <mat-paginator
      [length]="bloodReportTotalCount"
      [pageSize]="bloodReportPageSize"
      [pageIndex]="bloodReportPageIndex"
      (page)="onBloodReportPageChange($event)"
      showFirstLastButton>
    </mat-paginator>
  </div>

</div>
